import React from "react"
import styled from "styled-components"
import Heading from "@/common/components/_UI/Heading"
import NextImg from "@/common/components/NextImg/index"
import { theme, btnS, btnP } from "@/common/Mixin"

interface PermiseProps {
  content1: any[]
  content2: any[]
  result: string
  lineGroup: string
  themeNew: any
}

export default function ShowCasePremise({
  content1,
  content2,
  result,
  lineGroup,
  themeNew
}: PermiseProps) {
  return (
    <div style={{ width: "100%" }}>
      <Wrapper>
        <TitlesWrapper>
          {content1?.map((item, index) => (
            <Heading as="h3" content={item} key={index} />
          ))}
        </TitlesWrapper>

        <CardsWrapper themeNew={themeNew}>
          {content2?.map(({ Icon, content }, index) => (
            <CardWrapper key={index}>
              <ImageWrapper>
                <NextImg src={Icon} />
              </ImageWrapper>
              <ContentWrapper>{content}</ContentWrapper>
            </CardWrapper>
          ))}
        </CardsWrapper>
        <UnitWrapper>
          <NextImg src={lineGroup} />
        </UnitWrapper>
      </Wrapper>
      <ResultWrapper themeNew={themeNew}>
        <h3>{result}</h3>
      </ResultWrapper>
    </div>
  )
}

const Wrapper = styled.div`
  border-radius: var(--BORA) var(--BORA) 0 0;
  padding: var(--cardPadding);
  padding-bottom: 0;
  width: 100%;
  ${btnS}
  display: flex;
  flex-direction: column;
  /* gap: var(--cardGap); */
`

interface CardsWrapperProps {
  themeNew: any
}

const CardsWrapper = styled.div<CardsWrapperProps>`
  display: grid;
  margin-top: var(--cardGap);
  gap: var(--cardGap);
  grid-template-columns: repeat(3, 1fr);
  align-items: start;
  padding: 16px;
  border: 1px solid
    ${({ themeNew }) => (themeNew ? themeNew.primary : theme.color.primary)};
  border-radius: var(--cardBORA);

  @media (${theme.lg}) {
    margin-top: var(--cardGap);
    grid-template-columns: repeat(1, 1fr);
  }
`
const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  justify-items: center;
  gap: var(--textGap);
  @media (${theme.lg}) {
    grid-template-columns: 100px 1fr;
    justify-items: start;
  }
`
const ImageWrapper = styled.div`
  width: clamp(80px, 100%, 200px);
`
const ContentWrapper = styled.p`
  text-align: center;
  opacity: 1;
  color: white;
  @media (${theme.lg}) {
    text-align: left;
  }
`
const UnitWrapper = styled.div`
  width: 80%;
  margin: 0 auto -2vw;
`

interface ResultWrapperProps {
  themeNew: any
}

const ResultWrapper = styled.div<ResultWrapperProps>`
  ${btnP}
  border-radius: 0 0 var(--cardBORA) var(--cardBORA);
  padding: var(--cardPadding);
  h3 {
    color: ${({ themeNew }) => (themeNew ? "#000" : theme.color.secondary)};
    text-align: center;
  }
`
const TitlesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: var(--textGap);
  @media (${theme.md}) {
    h3 {
      font-size: var(--p);
      text-align: left;
    }
  }
`
